(ns app.front.ui.template-editor
  (:require [app.domain.fee.model :as fee-model]
            [app.domain.review.model :as review-model]
            [app.front.clipboard :as clipboard]
            [app.front.ui.blip :as ui-blip]
            [app.front.ui.select :as ui-select]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :as futil]
            [app.front.view.group.reporting.form-fields :as reporting-ff]
            [cljs.reader]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-sub ::selected-field
  :<- [::reporting-ff/selected]
  (fn [selected _]
    (-> selected (get nil) :field)))


(defn preview-modal [{:keys [tr on-close content-url]}]
  [:div.attachment-preview
   [:div.attachment-view-header
    (tr [:template-editor/preview-pdf])
    [:div.attachment-view-exit
     (cc/icon {:icon        i/remove
               :description (tr [:close])
               :class-name  "cursor-pointer"
               :on-click    on-close})]]
   [:div.iframe-container
    [:iframe {:src content-url}]]])


(defn pdf-preview [tr preview-url *preview?]
  (when @*preview?
    [preview-modal {:tr          tr
                    :content-url preview-url
                    :on-close    #(reset! *preview? false)}]))


(defn wrap-placeholder [s]
  (str "%" s "%"))


(defn form-field-select [tr *open? show-blip]
  (let [selected    (<sub [::selected-field])
        placeholder (wrap-placeholder (str "form-data" selected))]
    [:div.flex.flex-col.border-solid.border-blue-100.border-4.bg-white.px-2.pb-3.relative
     [:div.-mt-3 [reporting-ff/form-field-selector tr true]]
     (when (some? selected)
       [:div.flex.rounded.p-2.items-center.bg-blue-100.hover:bg-gray-400.cursor-pointer.max-w-md
        {:on-click (fn []
                     (show-blip (tr [:copied]))
                     (clipboard/copy-text placeholder)
                     (reset! *open? false))}
        [:div.flex-1 placeholder]
        (cc/icon {:description (tr [:template-editor/copy-placeholder])
                  :icon        i/link})])
     (cc/button {:kind             :ghost
                 :icon             i/remove
                 :icon-position    :right
                 :icon-description (tr [:project/edit-name])
                 :class-name       "ml-2 only-icon-button absolute top-0 right-0"
                 :on-click         #(reset! *open? false)}
                "")]))


(defn review-placeholder-text [id review-config]
  (str "%" id (some-> review-config :review.config/key name (#(str ":" %))) "%"))


(defn review-placeholder-select [tr id *open? show-blip {:keys [review-configs]}]
  (r/with-let [*review-config (r/atom nil)]
    (let [language    (<sub [:language])
          placeholder (review-placeholder-text id @*review-config)]
      [:div.flex.flex-col.border-solid.border-blue-100.border-4.bg-white.px-2.pb-3.pt-4.relative
       [ui-select/select {:id           (str id "-review-config")
                          :label-text   (tr [:review.config/select-review-config])
                          :values       review-configs
                          :val->str     #(review-model/review-config-name % language)
                          :value        @*review-config
                          :allow-empty? true
                          :empty-text   (tr [:review-comments/all])
                          :on-change    #(reset! *review-config %)}]
       (cc/button {:kind             :ghost
                   :class-name       "flex rounded p-2 mt-2 items-center bg-blue-100 hover:bg-gray-400 cursor-pointer max-w-md text-left"
                   :icon             i/link
                   :icon-description (tr [:template-editor/copy-placeholder])
                   :aria-label       (str (tr [:template-editor/copy-placeholder]) " " placeholder)
                   :on-click         (fn []
                                       (show-blip (tr [:copied]))
                                       (clipboard/copy-text placeholder)
                                       (reset! *open? false))}
                  [:div.flex-1 placeholder])
       (cc/button {:kind             :ghost
                   :icon             i/remove
                   :icon-position    :right
                   :icon-description (tr [:close])
                   :class-name       "ml-2 only-icon-button absolute top-0 right-0"
                   :on-click         #(reset! *open? false)}
                  "")])))


(def review-placeholder-ids #{"review-comments" "latest-review-comments"})


(defn placeholder [tr title id n-usages review-placeholder-options]
  (r/with-let [*ff-select-open? (r/atom false)]
    (let [placeholder  (wrap-placeholder id)
          used?        (pos? (or n-usages 0))
          form-data?   (= id "form-data")
          review-data? (contains? review-placeholder-ids id)]
      [:<>
       [ui-blip/blip
        (fn [show-blip]
          (if @*ff-select-open?
            (if form-data?
              [form-field-select tr *ff-select-open? show-blip]
              [review-placeholder-select tr id *ff-select-open? show-blip review-placeholder-options])
            [:li.my-2.rounded.p-2.flex.items-center.hover:bg-gray-400.cursor-pointer
             {:on-click (fn [_]
                          (if (or form-data? review-data?)
                            (reset! *ff-select-open? true)
                            (do (show-blip (tr [:copied]))
                                (clipboard/copy-text placeholder))))
              :class    (if used? "bg-ui-blue-10" "bg-ui-yellow")}
             [:div.flex-1
              [:div.flex.flex-wrap
               (if title
                 [:h5.mr-2 title]
                 [:div.mr-2.whitespace-nowrap.font-mono placeholder])
               [:div.whitespace-nowrap
                (str "(" (if used? n-usages (tr [:template-editor/unused-placeholder])) ")")]]
              (when title [:div.whitespace-nowrap.font-mono placeholder])]
             (cc/icon {:description (tr [:template-editor/copy-placeholder])
                       :icon        i/link})]))]])))

(defn placeholders-list [tr info-tr-key placeholders placeholder-usages review-placeholder-options]
  (when placeholders
    [:div.leading-tight
     (tr [info-tr-key])
     [:ul.mt-2
      (futil/for-frag [{:keys [title id]} placeholders]
        [placeholder tr title id (get placeholder-usages id) review-placeholder-options])]]))

(defn bad-placeholders-list [tr bad-placeholders]
  (when bad-placeholders
    [:div.leading-tight
     (tr [:template-editor/bad-placeholders-help])
     [:ul.mt-2
      (futil/for-frag [bad bad-placeholders]
        [:li.my-2.bg-ui-red-30.rounded.p-2 (wrap-placeholder bad)])]]))

(defn css-list [tr css-titles]
  [:div.leading-tight
   (tr [:verdict.template/additional-css-help])
   [:ul
    (futil/for-frag [title css-titles]
      [:li.my-2.bg-ui-blue-10.rounded.p-2>h5 title])]])

(defn images-list [tr images placeholder-usages]
  (when (seq images)
    [:div.leading-tight.mt-6
     (tr [:template-editor/image-info])
     [:ul.mt-2
      (futil/for-frag [{:file/keys [filename]} images]
        [placeholder tr filename filename (get placeholder-usages filename)])]]))

(defn summarize-placeholders
  ([placeholders images text]
   (summarize-placeholders placeholders images nil text))
  ([placeholders images valid-placeholder-ids text]
   (let [all    (->> text
                     (re-seq #"%([a-zA-Z\-0-9\._ \(\):]*)%")
                     (map second)
                     (remove (set (concat fee-model/fee-item-special-variables fee-model/receipt-special-variables)))
                     (map #(str/replace % #":.*" ""))
                     frequencies)
         valids (set (concat (map :id placeholders)
                             valid-placeholder-ids
                             (map :file/filename images)))]
     [(->> all
           keys
           (filter #(not (contains? valids %)))
           seq)
      all])))

(defn editor
  "An HTML/CSS template editor UI component.

  Props:
  `:tr`                    tr
  `:title`                 string, the text that is shown on the editor header
  `:html-template`         string, the HTML template to be edited
  `:print-css`             string, the CSS template to be edited
  `placeholders`           coll of `:title` & `:id`, that can be used to inject variable values into the template
  `:valid-placeholder-ids` coll of valid placeholder ids that are not shown in the placeholder list
  `on-save`                fn, takes two parameters; the saved HTML and CSS template strings
  `preview-url`            string, URL for a preview window of the PDF output of the template
  `:*editing?`             reagent atom, true if the editor is in editing mode (by default provided internally)
  `:small?`                if true, render as 20 rows tall, otherwise 50
  `:on-start-edit`         fn, called when the editor enters editing mode (by default resets *editing?)
  `:on-end-edit`           fn, called when the editor exits editing mode (by default resets *editing?)
  `:also-css`              a list of strings that tell the user where additional css could be concatenated from"
  [{:keys [tr
           html-template
           print-css
           placeholders
           valid-placeholder-ids
           images
           preview-url
           html-only?
           *editing?
           review-placeholder-options
           also-css]
    :as   props} children]
  (r/with-let [*preview? (r/atom false)
               *values   (r/atom (cond-> [html-template]
                                   (not html-only?) (conj print-css)))
               *editing? (or *editing? (r/atom false))
               *selected (r/atom 0)]
    (let [placeholders        (->> placeholders
                                   (map (fn [str-or-map]
                                          (if (string? str-or-map)
                                            {:id str-or-map}
                                            str-or-map))))
          [bad-placeholders
           used-placeholders] (summarize-placeholders
                                ;; placeholders only valid on HTML template
                                (when (= 0 @*selected) placeholders)
                                ;; images valid on both pages
                                images
                                ;; configured placeholders that should not be selectable, only valid on HTML template
                                (when (= 0 @*selected) valid-placeholder-ids)
                                (or (nth @*values @*selected) ""))]
      [:<>
       [pdf-preview tr preview-url *preview?]
       [text-editor/editor-external-state
        (merge props
               (util/mmap *values *editing? *selected)
               {:class        "font-mono"
                :contents     (concat
                                [{:label :template-editor/html-template
                                  :value html-template}]
                                (when-not html-only?
                                  [{:label :template-editor/css-template
                                    :value print-css}]))
                :instructions [:div.pr-4.flex-1
                               [bad-placeholders-list tr bad-placeholders]
                               (if (= 0 @*selected)
                                 [placeholders-list tr :template-editor/placeholders-info placeholders used-placeholders
                                  review-placeholder-options]
                                 [css-list tr also-css])
                               [images-list tr images used-placeholders]]
                :extra-button (when preview-url
                                (cc/button {:kind             :tertiary
                                            :on-click         #(reset! *preview? true)
                                            :icon             i/presentation
                                            :icon-description (tr [:template-editor/preview-pdf])
                                            :data-cy          "preview-button"}
                                           (tr [:template-editor/preview-pdf])))})
        children]])))
